import Api from './Api';
import Configuracao from '../util/Configuracao';

class ReembolsoMedicoApi extends Api {
  async consultarReembolsos (numProtocolo, numMatricula, seqPrestador, codEstado, numProcesso, anoProcesso, dataInicial, dataFinal) {
    try {
      const urlConsultarReembolsos = Configuracao.getConfiguracao().urlConsultarReembolsos +
      numProtocolo + '/' +
      numMatricula + '/' +
      seqPrestador + '/' +
      codEstado + '/' +
      numProcesso + '/' +
      anoProcesso + '/' +
      dataInicial + '/' +
      dataFinal;
      const response = await this.fetch(urlConsultarReembolsos, 'post');
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async incluirReembolso (reembolso) {
    try {
      const urlIncluirReembolso = Configuracao.getConfiguracao().urlIncluirReembolso;
      const response = await this.fetch(urlIncluirReembolso, 'put', reembolso);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async alterarReembolso (reembolso) {
    try {
      const urlAlterarReembolso = Configuracao.getConfiguracao().urlAlterarReembolso;
      const response = await this.fetch(urlAlterarReembolso, 'put', reembolso);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async excluirReembolso (numProtocolo) {
    try {
      const urlExcluirReembolso = Configuracao.getConfiguracao().urlExcluirReembolso + numProtocolo;
      const response = await this.fetch(urlExcluirReembolso, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarNomePrestador (CPF_CNPJ) {
    try {
      const urlConsultarReembolsosPrestador = Configuracao.getConfiguracao().urlConsultarReembolsosPrestador + CPF_CNPJ;
      const response = await this.fetch(urlConsultarReembolsosPrestador);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
}
export default ReembolsoMedicoApi;
